module Meevo.Components.BaseClasses {

  export class DefaultSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.DataMaintenance> {


  }
}